import { usePlayerActions } from "@utils/player/core/usePlayer";
import List from "@components/Collection/List";
import usePlaylistScreenData from "@components/Collection/playlist/usePlaylistScreenData";
import { handleArtistNavigation } from "@utils/index";
import { useCallback } from "react";
import { usePlaylistSuspense } from "@hooks/trpc/usePlaylists";

interface PersonalPlaylistProps {
  id: string;
  songId?: string;
}

const PersonalPlaylist = ({ id, songId }: PersonalPlaylistProps) => {
  const playerActions = usePlayerActions();

  const {
    query: { data: playlist, isFetching },
  } = usePlaylistSuspense(id);

  const { songs, isOwner, images } = usePlaylistScreenData(
    PersonalPlaylist.name,
    playlist,
    songId,
  );
  const playFromCollection = playerActions.playFromCollection;

  const handleSelectSong = useCallback(
    (songId: string) => {
      playFromCollection({
        songId,
        collectionType: "playlist",
        collectionId: id,
        collectionName: playlist?.title,
        songs,
      });
    },
    [id, playlist?.title, playFromCollection, songs],
  );

  const handlePress = () => {
    handleArtistNavigation({
      params: { isPlaylist: true, numberOfArtists: 0 },
    });
  };

  const subtitle = id === "discover_daily" ? "by Lissen" : "by You";

  const hasPrivateSong = playlist?.hasPrivateSong;

  return (
    <List
      id={id}
      image={images}
      isFetching={isFetching}
      isOwner={isOwner}
      isPublic={playlist?.visibility === "public"}
      onPress={handlePress}
      onSelectSong={handleSelectSong}
      songs={songs || []}
      subtitle={subtitle}
      title={playlist?.title}
      type="playlist"
      hasPrivateSong={hasPrivateSong}
    />
  );
};

export default PersonalPlaylist;
